import { trackEvent } from '@patrianna/analytics'
import { openDialog } from '@patrianna/dialog-manager'

import useBuilderCMSData from 'src/hooks/useBuilderCMSData'
import { useAppSelector } from 'src/store/hooks'
import { sweepstakeEnabledSelector } from 'src/store/modules/appConfig/selectors'
import { getQuickPurchaseOffersSelector, getQuickPurchaseFallbackSelector } from 'src/store/modules/shop/selectors'
import { getWidgetOffer } from 'src/store/modules/shop/utils/offers'

import { WidgetsVariant } from './types'
import type { WidgetBase } from './types'

const OFFER_WIDGET_DATA_MODEL = process.env.CMS_DATA_MODEL_OFFER_WIDGET
const QUICK_PURCHASE_ARRAY_LENGTH = 2

export const useOfferWidget = (): WidgetBase => {
  const isScEnabled = useAppSelector(sweepstakeEnabledSelector)

  const { builderData: offerData, builderDataLoaded } = useBuilderCMSData(OFFER_WIDGET_DATA_MODEL)
  const builderData = offerData[0]?.data

  const quickPurchaseOffers = useAppSelector((state) =>
    getQuickPurchaseOffersSelector(state, QUICK_PURCHASE_ARRAY_LENGTH),
  )
  const fallbackOffers = useAppSelector(getQuickPurchaseFallbackSelector)
  const offers = quickPurchaseOffers?.length ? quickPurchaseOffers : fallbackOffers

  const widgetOffer = getWidgetOffer(offers)
  const isWelcome = widgetOffer?.type === 'welcome'
  const imgSrc = isWelcome ? builderData?.welcomeOfferUrl : builderData?.specialOfferUrl
  const hasBuilderData = !!builderData && !!imgSrc

  const handleOfferClick = (): void => {
    if (!widgetOffer?.offer?.code) {
      return
    }
    trackEvent('offer_widget_clicked', { offer_code: widgetOffer.offer.code })
    openDialog({
      dialogName: 'QUICK_PURCHASE_DIALOG',
      dialogProps: { keepOpenOutsidePlayPage: true },
    })
  }

  return {
    id: WidgetsVariant.OFFER,
    isWidgetVisible: isScEnabled && !!widgetOffer && hasBuilderData && builderDataLoaded,
    imgSrc,
    imgAlt: builderData?.imageAlt || 'Offer',
    onClick: handleOfferClick,
  }
}
